var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.6 1.2h-2.618a4.35 4.35 0 0 0-3.086 1.289A4.42 4.42 0 0 0 7.618 5.6v2.64H5v3.52h2.618v7.04h3.491v-7.04h2.618l.873-3.52h-3.49V5.6c0-.233.091-.457.255-.622a.87.87 0 0 1 .617-.258H14.6z"
  })));
};
export default SvgFacebook;